<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-container">
                <!-- Menu header start -->
                <Navbar1 />
                <!-- Menu header end -->
                <div class="pcoded-main-container">

                    <Menu />
                    <!-- Sidebar inner chat end-->
                    <div class="pcoded-wrapper">
                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">

                                <!-- Main-body start -->
                                <div class="main-body">
                                    <div class="page-wrapper">
                                        <!-- Page-header start -->
                                        <div class="page-header card m-t-40">
                                            <div class="row align-items-end">
                                                <div class="col-lg-8">
                                                    <div class="page-header-title">
                                                        <i class="icofont icofont-restaurant-menu bg-c-pink "></i>
                                                        <div class="d-inline">
                                                            <h4>Stage 1</h4>
                                                            <span>Application</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Page-header end -->
                                        <!-- Page body start -->
                                        <div class="page-body">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <h5>Your Application</h5>
                                                            <div class="card-header-right">
                                                            </div>
                                                        </div>
                                                        <div class="card-block user-detail-card">
                                                            <div class="row">
                                                                <div class="col-sm-9 user-detail">
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-user"></i>First Name :</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.firstname}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-user"></i>Last Name :</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.lastname}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-calendar"></i>Age :</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.age}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-touch-phone"></i>Phone :</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.phonenumber}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-email"></i>Email Id :</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30"><a v-bind:href="'mailto:' + applicant.emailaddress">{{applicant.emailaddress}}</a></h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-graduate-alt"></i>Course :</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.course}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-hat"></i>Qualification:</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.education}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-certificate"></i>Grade :</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.grades}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-businessman"></i>Current or Immediate Past Employer:</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.current_employer}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="ti ti-linkedin"></i>LinkedIn:</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30"><a href="">{{applicant.linkedinprofile}}</a></h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Referrer:</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.referrer}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row"  v-show="applicant.referrer_name !== ''">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Referrer Name:</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{applicant.referrer_name}}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <h4 class="text-center mt-3">Job Listing Questions</h4>
                                                                    <div class="row" v-for="question in applicant.interview_answers">
                                                                        <div class="col-sm-5">
                                                                            <h6 class="f-w-400 m-b-30"><i class="icofont icofont-question-circle"></i>{{question.question}}</h6>
                                                                        </div>
                                                                        <div class="col-sm-7">
                                                                            <h6 class="m-b-30">{{question.answer}}</h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Default card end -->
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Page body end -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    @import '../assets/css/dashboard.css'

    .applicant{
        margin-top: 50px;
    }
    .applicant .info-block{
        display: block;
        padding: 9px;
    }
    .applicant .label{
        font-size: 15px;
        /*font-weight: bold;*/
    }
    .applicant .detail{
        font-size: 16px;
        font-weight: bold;
        padding-left: 20px;
    }
    tr td:nth-child(1){
        font-weight: bold;
    }
</style>
<script>
import Navbar1 from '../components/Navbar1.vue'
import Menu from '../components/Menu.vue'
export default {
    name: 'Stage2',
    data(){
        return{
            applicant: {
                firstname: 'Loading...',
                lastname: 'Loading...',
                age: 'Loading...',
                phonenumber: 'Loading...',
                emailaddress: 'Loading...',
                course: 'Loading...',
                grades: 'Loading...',
                current_employer: 'Loading...',
                linkedinprofile: 'Loading...',
                referrer: 'Loading...',
                documents: [
                    {
                        id: 'Loading...',
                        link: 'Loading...'
                    }
                ]
            },
            applicant_id: '',
            opening_id: '',
            opening: []
        }
    },
    mounted(){

        var user_data = this.$store.getters.user_data.data
        this.applicant_id = user_data.id
        this.opening_id = user_data.joblisting_id

        // this.user_data = user_data

        // this.applicant = user_data

        this.getOpening(this.opening_id)
    },
    methods:{
        getOpening(id){

            var get_openings_request = {
                what: 'ListApplicants',
                id: this.applicant_id
            }

            this.$socket.makeGetRequest(get_openings_request)
                .then((response)=>{
                    if(response.type == 'ListApplicants'){
                        // this.opening = response.data
                        this.applicant = response.data
                        // this.getApplicantInfoFromOpening(this.applicant_id)
                    }
                })
                .catch((e)=>{
                    console.log(e)
                })
        },

        getApplicantInfoFromOpening(applicant_id){
            var applicant_index = this.getApplicantIndex(applicant_id)
            this.applicant = this.opening[applicant_index]
        },

        getApplicantIndex(applicant_id){

            var index = 0
            var opening = this.opening

            for(var i=0;i<opening.length;i++){
                if(opening[i].id == applicant_id){
                    index = i
                    break
                }
            }

            return index
        }
    },
    components:{
        Navbar1,
        Menu
    }
}
</script>
